var _title, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgStarIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "34px",
    height: "32px",
    viewBox: "0 0 34 32",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "star_icon")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u05D4\\u05E2\\u05D1\\u05E8\\u05D5\\u05EA",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "5_Kavei_Extra_services_BlueBird_Priority_Pass_main",
    transform: "translate(-1143.000000, -273.000000)",
    fill: "#464646",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "grade_black_24dp",
    transform: "translate(1143.000000, 273.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "16.896 25.4607158 27.337728 31.68 24.566784 19.9584 33.792 12.0717474 21.643776 11.0546526 16.896 0 12.148224 11.0546526 0 12.0717474 9.225216 19.9584 6.454272 31.68"
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgStarIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/star-icon.7bd7533c.svg";
export { ForwardRef as ReactComponent };